import React from 'react';
import { HomeIcon } from 'lucide-react';
interface BrandHeaderProps {
  periodLabel: string;
}
export function BrandHeader({
  periodLabel
}: BrandHeaderProps) {
  return <div className="bg-navy-deep" data-id="element-1" data-mp="1jlf5ixysh26c">
      <div className="mx-auto flex max-w-[1600px] items-center gap-6 px-6 py-3" data-id="element-2" data-mp="1jknc9tsnzgj8">
        <div className="flex items-center gap-2.5" data-id="element-3" data-mp="1emu4wxfmkghd">
          <HomeIcon className="h-6 w-6 text-white" strokeWidth={1.75} data-id="element-4" data-mp="1em28xli48gqk" />
          <div className="leading-none" data-id="element-5" data-mp="19oak50crpaql">
            <p className="text-base font-bold uppercase tracking-[0.08em] text-white" data-id="element-6" data-mp="19kwdvh0zghdv">
              Mortgage Express
            </p>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.12em] text-white/55" data-id="element-7" data-mp="10m18261up9b3">
              NMLS #1916307
            </p>
          </div>
        </div>

        <nav aria-label="Commission tools" className="ml-6 hidden items-center gap-1 lg:flex" data-id="element-8" data-mp="vpsxz72ig6as">
          <NavLink active data-id="element-9" data-mp="2uy7tdxogl6h4">Commission run</NavLink>
          <NavLink data-id="element-10" data-mp="2q2ittucfvpkt">Pipeline</NavLink>
          <NavLink data-id="element-11" data-mp="2pzefi459fdgf">Rate rules</NavLink>
          <NavLink data-id="element-12" data-mp="11uapswdvu63h">Payout history</NavLink>
        </nav>

        <div className="ml-auto flex items-center gap-4" data-id="element-13" data-mp="11wwvsrl4kdjl">
          <span className="hidden text-sm font-medium text-white/60 sm:inline" data-id="element-14" data-mp="15xgrdqq1v93m">
            {periodLabel} run
          </span>
          <span className="flex items-center gap-2 rounded-sm bg-white/10 px-2.5 py-1.5" data-id="element-15" data-mp="ry7f324ysz4x">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-orange text-[11px] font-bold text-white" data-id="element-16" data-mp="ww95y98mu2qy">
              BK
            </span>
            <span className="text-xs font-medium text-white/85" data-id="element-17" data-mp="1pkwjtjr1xpuh">Brandon K.</span>
          </span>
        </div>
      </div>
    </div>;
}
function NavLink({
  children,
  active = false
}: {
  children: React.ReactNode;
  active?: boolean;
}) {
  return <button type="button" aria-current={active ? 'page' : undefined} className={`rounded-sm px-3 py-1.5 text-sm font-medium transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-orange ${active ? 'bg-orange text-white' : 'text-white/65 hover:bg-white/10 hover:text-white'}`} data-id="element-18" data-mp="1fsig4lgey95o">
      {children}
    </button>;
}